import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/projekty')({
  component: ProjektyLayout,
})

/** Layout dla /projekty i podstron (/nowy, /$projectId, etc.) */
function ProjektyLayout() {
  return <Outlet />
}
